import Canvas from '../components/Canvas';

export default function SigningDocument() {
  return (
    <>
      <Canvas></Canvas>
    </>
  );
}
